// Çeviri sözlüğü (tr varsayılan, en). Anahtar bulunamazsa önce tr'ye, o da
// yoksa anahtarın kendisine düşülür (bkz. LanguageContext.t).
// Şimdilik çekirdek UI çevrilidir (sidebar/menü, profil, ayarlar). Diğer
// sayfalar aşama aşama bu sözlüğe eklenebilir.

export const LANGUAGES = [
  { id: "tr", name: "Türkçe", flag: "🇹🇷" },
  { id: "en", name: "English", flag: "🇬🇧" },
];

export const DEFAULT_LANG = "tr";

const tr = {
  // Sidebar / menü
  "nav.dashboard": "Dashboard",
  "nav.salonManagement": "Salon Yönetimi",
  "nav.salons": "Salonlar",
  "nav.onboarding": "Salon Onboarding",
  "nav.packages": "Paket Yönetimi",
  "nav.subscriptionRequests": "Lisans Talepleri",
  "nav.hierarchy": "Salon Hiyerarşisi",
  "nav.systemAdmins": "Sistem Yöneticileri",
  "nav.systemSettings": "Sistem Duyuru Ayarları",
  "nav.mySalon": "Salonum",
  "nav.subscription": "Paketim & Lisansım",
  "nav.appointments": "Randevular",
  "nav.tasks": "Yapılacaklar",
  "nav.documents": "Dökümanlar",
  "nav.staff": "Personel",
  "nav.customers": "Müşteriler",
  "nav.services": "Hizmetler",
  "nav.inventory": "Stok",
  "nav.payroll": "Prim & Maaş",
  "nav.cash": "Kasa",
  "nav.finance": "Finans",
  "nav.campaigns": "Kampanyalar",
  "nav.loyalty": "Sadakat",
  "nav.invoices": "Faturalar",
  "nav.reports": "Raporlar",
  "nav.devNotes": "Geliştirme Notları",
  "nav.versions": "Versiyon Notları",
  "nav.roadmap": "Gelecek Özellikler",
  // Menü kategorileri
  "nav.group.crm": "Müşteri & Pazarlama",
  "nav.group.catalog": "Katalog",
  "nav.group.team": "Ekip Personel",
  "nav.group.finance": "Finans",
  "nav.group.account": "Salon & Hesap",
  "sidebar.collapse": "Menüyü Daralt",
  "sidebar.expand": "Menüyü Genişlet",

  // Profil menüsü
  "profile.settings": "Profil & Tema",
  "profile.changePassword": "Şifre Değiştir",
  "profile.cashPassword": "Kasa Şifresi",
  "profile.lock": "Ekranı Kilitle",
  "profile.logout": "Çıkış Yap",
  "profile.category.appearance": "Görünüm & Dil",
  "profile.category.security": "Güvenlik & Şifre",
  "profile.category.session": "Oturum",
  "profile.settings.theme": "Tema Ayarları",
  "profile.settings.lang": "Dil Ayarları",
  "profile.settings.2fa": "İki Adımlı Doğrulama",

  // Ayarlar sayfası
  "settings.title": "Profil & Ayarlar",
  "settings.theme.title": "Tema Ayarları",
  "settings.theme.desc":
    "Salonunuzun görsel kimliğini seçin. Tema; kenar çubuğu, butonlar, kartlar, grafikler, rozetler ve takvim renklerini etkiler — düzen değişmez.",
  "settings.theme.active": "Aktif",
  "settings.theme.applied": "{name} teması uygulandı.",
  "settings.theme.premiumNote":
    "premium temaları yalnızca Gold pakette açılır. Yükseltmek için yöneticinizle iletişime geçin.",
  "settings.lang.title": "Dil",
  "settings.lang.desc": "Arayüz dilini seçin.",
  "settings.lang.applied": "Dil güncellendi.",

  // İki adımlı doğrulama (2FA)
  "settings.2fa.title": "İki Adımlı Doğrulama",
  "settings.2fa.desc":
    "Açık olduğunda, e-posta ve şifreyle giriş yaptıktan sonra telefonunuza SMS ile gelen 6 haneli kodu girmeniz istenir (kod 2 dakika geçerlidir).",
  "settings.2fa.toggle": "SMS ile iki adımlı doğrulama",
  "settings.2fa.on": "Açık",
  "settings.2fa.off": "Kapalı",
  "settings.2fa.enabled": "İki adımlı doğrulama açıldı.",
  "settings.2fa.disabled": "İki adımlı doğrulama kapatıldı.",
  "settings.2fa.goldOnly": "İki adımlı doğrulama yalnızca Gold pakette kullanılabilir.",
  "settings.2fa.needPhone": "2FA için hesabınızda kayıtlı bir telefon numarası olmalı.",

  // Tema açıklamaları
  "theme.light.desc": "Mevcut aydınlık kimlik; ferah ve nötr.",
  "theme.dark.desc": "Yumuşak slate tonlu, gözü yormayan gece teması.",
  "theme.rose.desc": "Pudra pembe, rose gold ve lila tonlarıyla zarif, feminen premium.",
  "theme.luxe.desc": "Siyah/antrasit, altın ve şampanya tonlarıyla lüks, VIP salon hissi.",
  "theme.botanica.desc": "Adaçayı yeşili, krem ve doğal tonlarla sakin spa/wellness teması.",

  // Fatura / Makbuz PDF (yazdırma) çıktısı
  "inv.pdf.loading": "Fatura detayları yükleniyor...",
  "inv.pdf.loadError": "Fatura detayları yüklenemedi.",
  "inv.pdf.titleInvoice": "E-ARŞİV FATURA",
  "inv.pdf.titleReceipt": "MAKBUZ",
  "inv.pdf.taxOfficeShort": "V.D",
  "inv.pdf.taxOfficeDefault": "Güzellik V.D.",
  "inv.pdf.taxNoLabel": "Vergi / TC No",
  "inv.pdf.docNo": "Belge No",
  "inv.pdf.date": "Tarih",
  "inv.pdf.dueDate": "Vade",
  "inv.pdf.status": "Durum",
  "inv.pdf.statusIssued": "ONAYLI",
  "inv.pdf.statusCancelled": "İPTAL EDİLDİ",
  "inv.pdf.customerInfo": "Müşteri / Alıcı Bilgileri",
  "inv.pdf.retail": "İşyeri / Perakende",
  "inv.pdf.customerTaxNo": "T.C. / Vergi No",
  "inv.pdf.customerTaxOffice": "Vergi Dairesi",
  "inv.pdf.sourceTx": "Kaynak İşlem",
  "inv.pdf.colDesc": "Hizmet / Ürün Açıklaması",
  "inv.pdf.colType": "Tür",
  "inv.pdf.colQty": "Miktar",
  "inv.pdf.colUnitPrice": "Birim Fiyat",
  "inv.pdf.colVat": "KDV",
  "inv.pdf.colAmount": "Tutar",
  "inv.pdf.typeService": "Hizmet",
  "inv.pdf.typeProduct": "Ürün",
  "inv.pdf.legalNote": "İşbu fatura 213 Sayılı Vergi Usul Kanunu uyarınca düzenlenmiştir.",
  "inv.pdf.stamp": "KAŞE / İMZA",
  "inv.pdf.subtotal": "Mal/Hizmet Toplamı",
  "inv.pdf.vatTotal": "Hesaplanan KDV Toplamı",
  "inv.pdf.discountTotal": "Toplam İndirim",
  "inv.pdf.grandTotal": "Ödenecek Tutar",

  // Tablo genel export (PDF/Excel) başlıkları
  "table.pdf.title": "Veri Raporu",
  "table.pdf.date": "Tarih",
};

const en = {
  // Sidebar / menu
  "nav.dashboard": "Dashboard",
  "nav.salonManagement": "Salon Management",
  "nav.salons": "Salons",
  "nav.onboarding": "Salon Onboarding",
  "nav.packages": "Package Management",
  "nav.subscriptionRequests": "License Requests",
  "nav.hierarchy": "Salon Hierarchy",
  "nav.mySalon": "My Salon",
  "nav.appointments": "Appointments",
  "nav.tasks": "Tasks",
  "nav.documents": "Documents",
  "nav.staff": "Staff",
  "nav.customers": "Customers",
  "nav.services": "Services",
  "nav.inventory": "Inventory",
  "nav.payroll": "Payroll",
  "nav.cash": "Cash Register",
  "nav.finance": "Finance",
  "nav.campaigns": "Campaigns",
  "nav.loyalty": "Loyalty",
  "nav.invoices": "Invoices",
  "nav.reports": "Reports",
  "nav.devNotes": "Development Notes",
  "nav.versions": "Version Notes",
  "nav.roadmap": "Roadmap",
  // Menu categories
  "nav.group.crm": "Customers & Marketing",
  "nav.group.catalog": "Catalog",
  "nav.group.team": "Team Staff",
  "nav.group.finance": "Finance",
  "nav.group.account": "Salon & Account",
  "sidebar.collapse": "Collapse menu",
  "sidebar.expand": "Expand menu",

  // Profile menu
  "profile.settings": "Profile & Theme",
  "profile.changePassword": "Change Password",
  "profile.cashPassword": "Cash Password",
  "profile.lock": "Lock Screen",
  "profile.logout": "Log Out",
  "profile.category.appearance": "Appearance & Language",
  "profile.category.security": "Security & Password",
  "profile.category.session": "Session",
  "profile.settings.theme": "Theme Settings",
  "profile.settings.lang": "Language Settings",
  "profile.settings.2fa": "Two-Factor Auth",

  // Settings page
  "settings.title": "Profile & Settings",
  "settings.theme.title": "Theme Settings",
  "settings.theme.desc":
    "Choose your salon's visual identity. The theme affects the sidebar, buttons, cards, charts, badges and calendar colors — the layout stays the same.",
  "settings.theme.active": "Active",
  "settings.theme.applied": "{name} theme applied.",
  "settings.theme.premiumNote":
    "premium themes are only unlocked on the Gold package. Contact your administrator to upgrade.",
  "settings.lang.title": "Language",
  "settings.lang.desc": "Choose the interface language.",
  "settings.lang.applied": "Language updated.",

  // Two-factor authentication (2FA)
  "settings.2fa.title": "Two-Factor Authentication",
  "settings.2fa.desc":
    "When enabled, after logging in with email and password you'll be asked for a 6-digit code sent to your phone via SMS (valid for 2 minutes).",
  "settings.2fa.toggle": "Two-factor authentication via SMS",
  "settings.2fa.on": "On",
  "settings.2fa.off": "Off",
  "settings.2fa.enabled": "Two-factor authentication enabled.",
  "settings.2fa.disabled": "Two-factor authentication disabled.",
  "settings.2fa.goldOnly": "Two-factor authentication is only available on the Gold package.",
  "settings.2fa.needPhone": "You need a registered phone number on your account for 2FA.",

  // Theme descriptions
  "theme.light.desc": "The current light identity; airy and neutral.",
  "theme.dark.desc": "Soft slate-toned night theme that's easy on the eyes.",
  "theme.rose.desc": "Elegant, feminine premium with powder pink, rose gold and lilac tones.",
  "theme.luxe.desc": "Luxurious VIP feel with black/anthracite, gold and champagne tones.",
  "theme.botanica.desc": "Calm spa/wellness theme with sage green, cream and natural tones.",

  // Invoice / Receipt PDF (print) output
  "inv.pdf.loading": "Loading invoice details...",
  "inv.pdf.loadError": "Failed to load invoice details.",
  "inv.pdf.titleInvoice": "E-ARCHIVE INVOICE",
  "inv.pdf.titleReceipt": "RECEIPT",
  "inv.pdf.taxOfficeShort": "Tax Off.",
  "inv.pdf.taxOfficeDefault": "Tax Office",
  "inv.pdf.taxNoLabel": "Tax / ID No",
  "inv.pdf.docNo": "Document No",
  "inv.pdf.date": "Date",
  "inv.pdf.dueDate": "Due Date",
  "inv.pdf.status": "Status",
  "inv.pdf.statusIssued": "APPROVED",
  "inv.pdf.statusCancelled": "CANCELLED",
  "inv.pdf.customerInfo": "Customer / Recipient Details",
  "inv.pdf.retail": "Business / Retail",
  "inv.pdf.customerTaxNo": "ID / Tax No",
  "inv.pdf.customerTaxOffice": "Tax Office",
  "inv.pdf.sourceTx": "Source Transaction",
  "inv.pdf.colDesc": "Service / Product Description",
  "inv.pdf.colType": "Type",
  "inv.pdf.colQty": "Qty",
  "inv.pdf.colUnitPrice": "Unit Price",
  "inv.pdf.colVat": "VAT",
  "inv.pdf.colAmount": "Amount",
  "inv.pdf.typeService": "Service",
  "inv.pdf.typeProduct": "Product",
  "inv.pdf.legalNote": "This invoice has been issued in accordance with Turkish Tax Procedure Law No. 213.",
  "inv.pdf.stamp": "STAMP / SIGNATURE",
  "inv.pdf.subtotal": "Goods/Services Subtotal",
  "inv.pdf.vatTotal": "Total Calculated VAT",
  "inv.pdf.discountTotal": "Total Discount",
  "inv.pdf.grandTotal": "Amount Due",

  // Generic table export (PDF/Excel) headings
  "table.pdf.title": "Data Report",
  "table.pdf.date": "Date",
};

export const TRANSLATIONS = { tr, en };
